// RPM Field Chart Constants
export const RPM_FIELD_COUNT = 9
export const RPM_FIELD_LETTERS = Array.from({ length: RPM_FIELD_COUNT }, (_, i) => 
  String.fromCharCode(65 + i),
) // ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']

// Generate RPM field name
export const generateRpmFieldName = (letter, chartId = '') => 
  `rpmField${letter}chart${chartId}`

// Generate all RPM field names for a chart
export const generateAllRpmFieldNames = (chartId = '') => 
  RPM_FIELD_LETTERS.map(letter => generateRpmFieldName(letter, chartId))
